import { render, staticRenderFns } from "./internationalDetailPage.vue?vue&type=template&id=56b1535c&scoped=true&"
import script from "./internationalDetailPage.vue?vue&type=script&lang=js&"
export * from "./internationalDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./internationalDetailPage.vue?vue&type=style&index=0&id=56b1535c&prod&lang=scss&scoped=true&"
import style1 from "./internationalDetailPage.vue?vue&type=style&index=1&id=56b1535c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b1535c",
  null
  
)

export default component.exports